const AUTH_RETURN_PATH_KEY = 'groupardy.authReturnPath';

export const saveAuthReturnPath = (path) => {
  localStorage.setItem(AUTH_RETURN_PATH_KEY, path);
};

export const getAuthReturnPath = () => {
  return localStorage.getItem(AUTH_RETURN_PATH_KEY);
};

export const clearAuthReturnPath = () => {
  localStorage.removeItem(AUTH_RETURN_PATH_KEY);
};
